export var max = Math.max;
export var min = Math.min;
export var round = Math.round;


//////////////////
// WEBPACK FOOTER
// /var/www/24tru/releases/20230713222349/htdocs-rails/node_modules/@popperjs/core/lib/utils/math.js
// module id = 93
// module chunks = 0 1 2 3 5 6